// extracted by mini-css-extract-plugin
export default {"TagList":"ViewAllAccesses_TagList__O8qix","Tags":"ViewAllAccesses_Tags__HwS-i"};